import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import axios from "axios";
import AllPagesNavbar from "./Navbar";
import Loading from "./Loading";
import { BiSolidEditAlt } from "react-icons/bi";
import { useLocation } from "react-router-dom";

import "./../CSS/EngineMaster.css";
const PROPELLERMASTER = () => {
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;

  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sclientSecret = window.sessionStorage.getItem("sclientSecret");
  const state = useSelector((state) => state?.loginreducer);
  const date = new Date().toISOString();
  const userPass = state?.user?.userCode;

  const [PassPROPELLERNO, setPassPROPELLERNO] = useState("");
  const [search, setSearch] = useState("");
  const [PropellerList, setPropellerList] = useState([]);
  const [seldivision, setSelDivision] = useState("");

  const [isloading, setisloading] = useState(false);

  const [PassLASTOVERREADING, setPassLASTOVERREADING] = useState("");
  const [PassLASTOVERHAULDATE, setPassLASTOVERHAULDATE] = useState("");

  useEffect(() => {
    FetchDetails();
  }, []);
  function FetchDetails() {
    setisloading(true);
    axios
      // .get(`${BASEURL}/getPropellerMaster`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=515`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((res) => {
        console.log(res.data);
        setisloading(false);
        setPropellerList(res?.data);
      })
      .catch((err) => {
        setisloading(false);
        console.log("Error while fetching /getPropellers List", err);
      });
  }
  const filteredData = PropellerList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    const divisionMatch = !seldivision || item.DIVISIONCODE === seldivision;

    if (searchData.length === 0) {
      return divisionMatch;
    }

    const textMatch = searchData.every((term) => {
      return [
        "LASTVALUEAFTEROVERHAUL",
        "LASTOVERHAULDATE",
        "ENGINESERIALNO",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch && divisionMatch;
  });

  const HandleSave = async () => {
    if (!PassLASTOVERHAULDATE) {
      alert("Please Provide LAST OVERHAUL DATE");
      return;
    }
    if (!PassLASTOVERREADING) {
      alert("Please Provide LAST OVER READING");
      return;
    }

    const confirmEdit = window.confirm("Are you sure you want to Save?");
    if (confirmEdit) {
      const datePass = PassLASTOVERHAULDATE.slice(0, 10);

      setisloading(true);
      console.log({
        ENGINENO: PassPROPELLERNO,
        LASTOVERHAULDATE: datePass,
        LASTOVERREADING: Number(PassLASTOVERREADING),
      });
      try {
        const LICENSEResponse = await axios.post(
          // `${BASEURL}/insertPropellerMaster`,
          `${BASEURL_GLOBAL}/globalSpHandler?spname=190 `,
          {
            PROPELLERNO: PassPROPELLERNO,
            LASTOVERHAULDATE: datePass,
            LASTOVERREADING: Number(PassLASTOVERREADING),
            SUCCESS_STATUS: "",
            ERROR_STATUS: "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sclientSecret,
            },
          }
        );
        alert(LICENSEResponse.data.message);
        window.location.reload();
        setisloading(false);
      } catch (error) {
        setisloading(false);
        alert(error.message);
      }
    }
  };
  function handleEdit(item) {
    setPassPROPELLERNO(item.ENGINESERIALNO);
    setPassLASTOVERREADING(item.LASTVALUEAFTEROVERHAUL);
    setPassLASTOVERHAULDATE(item.LASTOVERHAULDATE.slice(0, 10));
  }

  const scrollToSection = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  if (isloading) {
    return <Loading />;
  }

  return (
    <div className="bg-gray-50 min-h-[100vh] newpages__input">
      <AllPagesNavbar />
      <header className="header__of__main lg:flex justify-between items-end px-3">
        <h1 className="header__of__page">{menu || "PROPELLER MASTER"}</h1>
        <div className="lg:flex items-center gap-5 my-1">
          {" "}
          <button
            onClick={() => {
              window.location.reload();
            }}
            className="border-l-indigo-900 rounded mx-2 text-white"
          >
            New
          </button>
          <button
            onClick={async () => {
              if (!PassPROPELLERNO) {
                alert("Kindly Supply PROPELLER NO");
              } else {
                HandleSave();
              }
            }}
            className="border-l-indigo-900 rounded mx-2 text-white"
          >
            Save
          </button>
        </div>
      </header>
      <aside className="m-5">
        <section className="lg:flex  gap-10">
          <div>
            <p>PROPELLER NO</p>
            <input
              className="h-9 px-1"
              type="text"
              value={PassPROPELLERNO}
              onChange={(e) => setPassPROPELLERNO(e.target.value)}
            />
          </div>
          <div>
            <p>LAST OVERHAUL DATE</p>
            <input
              type="date"
              className="h-9 px-1"
              value={PassLASTOVERHAULDATE}
              onChange={(e) => setPassLASTOVERHAULDATE(e.target.value)}
            />
          </div>
          <div>
            <p>LAST OVERHAUL READING</p>
            <input
              type="number"
              className="h-9 px-1"
              value={PassLASTOVERREADING}
              onChange={(e) => setPassLASTOVERREADING(e.target.value)}
            />
          </div>
        </section>
      </aside>
      {isloading ? (
        <Loading />
      ) : (
        <div className="z-10 lg:flex  flex-col w-full">
          <div>
            <div className="lg:flex mx-6">
              <p>Search:</p>
              <input
                className="w-[300px] h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>
            <div className="overflow-y-auto h-[500px] px-4">
              <table className="custom-table  overflow__y__ relative text-[12px] ">
                <thead
                  className="header-cell sticky top-[0px] left-[10px]"
                  style={{ zIndex: 50 }}
                >
                  <tr>
                    <td className="text-right">
                      <p>ENGINE SERIAL NO </p>
                    </td>
                    <td className="text-right">LAST OVERHAUL DATE </td>
                    <td className="text-right">LAST OVERHAUL READING</td>

                    <td className="w-[120px]">EDIT</td>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length > 0 &&
                    filteredData.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        <td className=" pr-5 text-right">
                          {item.ENGINESERIALNO ? item.ENGINESERIALNO : "NA"}
                        </td>

                        <td className="">
                          {item.LASTOVERHAULDATE
                            ? item.LASTOVERHAULDATE.slice(8, 10) +
                              "/" +
                              item.LASTOVERHAULDATE.slice(5, 7) +
                              "/" +
                              item.LASTOVERHAULDATE.slice(0, 4)
                            : "NA"}
                        </td>
                        <td className=" pr-5 text-right">
                          {item.LASTVALUEAFTEROVERHAUL
                            ? item.LASTVALUEAFTEROVERHAUL
                            : "NA"}
                        </td>
                        <td
                          className="w-[100px]"
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontSize: "22px",
                          }}
                          onClick={() => {
                            handleEdit(item);
                            scrollToSection();
                          }}
                        >
                          <BiSolidEditAlt />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PROPELLERMASTER;
